import { Middleware } from '@reduxjs/toolkit';

/**
 * Log a warning and show a toast!
 */
export const errorLoggingMiddleware: Middleware = () => (next) => (action) => {
  return next(action);
};
